<template>
  <div class="FX_title_box">
    <div style="margin-left: 1rem; position: relative">
      <!-- 青創指揮部&#8194;<i class="el-icon-close"></i>&#8194;中原育成&#8194;<i class="el-icon-close"></i>&#8194;安東青創 -->
      <div class="title_box1">
        <!-- 青指部&#8194;<i class="el-icon-close"></i>&#8194;安東&#8194;<i
          class="el-icon-close"
        ></i
        > -->
        &#8194;青創資源中心&中原育成 線上服務系統
      </div>
      <div class="title_box2">
        線上服務系統<br />
        <span style="font-size: 0.6rem">
          <!-- 青指部&#8194;<i class="el-icon-close"></i>&#8194;安東&#8194;<i
            class="el-icon-close"
          ></i
          > -->
          &#8194;中原育成</span
        >
      </div>
    </div>

    <!-- <div class="user_button" @click=" showMemberForm = true "><i class="el-icon-s-custom" ></i></div> -->

    <!-- <el-dialog title="會員資料" :visible.sync="showMemberForm" >
          <headerMemberForm @click="showMemberForm = false" />
        </el-dialog> -->
  </div>
</template>

<script>
// import headerMemberForm from './TheHeaderMemberForm'
// import { Popup } from "vant";
// import { mapGetters } from "vuex";
export default {
  data() {
    return {
      // showMemberForm:false,
    };
  },
};
</script>

<style scoped>
.FX_title_box {
  width: 100%;
  height: 50px;
  background-color: #07003b;
  color: #ffffff;
  font-family: 微軟正黑體;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 50px;
  /* padding: 0 1rem; */
  position: relative;
}
.FX_title_box .user_button {
  border-style: solid;
  display: inline-block;
  width: 30px;
  height: 30px;
  position: absolute;
  border-radius: 50%;
  border-width: 2px;
  text-align: center;
  line-height: 27px;
  font-size: 1.3rem;
  right: 1rem;
  top: 8px;
  cursor: pointer;
}

.title_box1 {
  display: inline-block;
}
.title_box2 {
  line-height: 18px;
  display: none;
  vertical-align: middle;
  font-size: 0.9rem;
}

@media screen and (max-width: 460px) {
  .title_box2 {
    display: inline-block;
  }
  .title_box1 {
    display: none;
  }
}
</style>
